<template>
  <div class="product-detail">
    <div class="wp2">
      <div class="page-back">
        <img src="@/assets/images/back.png" alt="back" @click="$router.back()" />
      </div>
      <section class="top-info">
        <div class="left" v-if="goodsList.length > 0">
          <thumbsSwiper :goods-list="lang === 'zh' ? goodsList : goodsListEn" />
        </div>
        <div class="right">
          <!-- <div class="crumb">
						<span>{{ $t('productDetail.crumb.1') }}</span>
						<em>&gt;</em>
						<span>{{ $t('productDetail.crumb.2') }}</span>
						<em>&gt;</em>
						<span>{{lang === 'zh' ? product.brand_cn : product.brand_en}}</span>
					</div> -->
          <div class="title">
            {{ lang === 'zh' ? product.item_cn : product.item_en }}
          </div>
          <div class="form">
            <div class="row">
              <div class="label">{{ $t('productDetail.form.1') }}</div>
              <div class="value">{{ product.sku }}</div>
            </div>
            <div class="row">
              <div class="label">{{ $t('productDetail.form.2') }}</div>
              <div class="value">{{ product.sku_box }}</div>
            </div>
            <div class="row">
              <div class="label">{{ $t('productDetail.form.3') }}</div>
              <div class="value">{{ product.shelf_life }}</div>
            </div>
            <div class="row">
              <div class="label">{{ $t('productDetail.form.4') }}</div>
              <div class="value">
                {{ product.upc }}
                <img
                  :alt="lang === 'zh' ? product.item_cn : product.item_en"
                  :src="product.barcodeUrl"
                />
              </div>
            </div>
            <div class="row">
              <div class="label">{{ $t('productDetail.form.55') }}</div>
              <div class="value" v-if="product.box_net_weight">
                {{ product.box_net_weight }}（kg）
              </div>
              <div class="value" v-else></div>
            </div>
            <div class="row">
              <div class="label">{{ $t('productDetail.form.5') }}</div>
              <div class="value" v-if="product.box_weight">{{ product.box_weight }}（kg）</div>
              <div class="value" v-else></div>
            </div>
            <div class="row">
              <div class="label">{{ $t('productDetail.form.6') }}</div>
              <div class="value">{{ product.box_vol }}</div>
            </div>
            <div class="row">
              <div class="label">{{ $t('productDetail.form.66') }}</div>
              <div class="value">{{ product.prod_vol }}</div>
            </div>
            <div class="row">
              <div class="label">{{ $t('productDetail.form.7') }}</div>
              <div class="value">{{ product.box_upc }}</div>
            </div>
          </div>
        </div>
      </section>
      <article class="detail">
        <h3 class="title">
          {{ $t('productDetail.secTit1') }}
          <div
            class="icon"
            :class="showDetail ? 'open' : ''"
            @click="showDetail = !showDetail"
          ></div>
        </h3>
        <div
          class="content"
          v-if="showDetail"
          v-html="lang === 'zh' ? product.decription_cn : product.decription_en"
        ></div>
      </article>
      <section class="rec">
        <h3 class="title">{{ $t('productDetail.secTit2') }}</h3>
        <div class="goods-list2" v-if="recList.length > 0">
          <goodsItem
            v-for="(item, index) in lang === 'zh' ? recList : recListEn"
            :key="index"
            :item="item"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import thumbsSwiper from '@/views/product/modules/thumbsSwiper'
import goodsItem from '@/components/goodsItem'

export default {
  name: 'productDetail',
  props: ['pid'],
  components: {
    thumbsSwiper,
    goodsItem
  },
  data() {
    return {
      lang: this.$i18n.locale,
      product: {},
      goodsList: [],
      goodsListEn: [],
      recList: [],
      recListEn: [],
      showDetail: false
    }
  },
  created() {
    this.getProdDetail()
    this.getSimProds()
  },
  mounted() {
    window.scrollTo(0, 0)
    this.changeBanner()
    this.initListener()
  },
  destroyed() {
    this.destroyListener()
  },
  methods: {
    async getProdDetail() {
      const { data: res } = await this.$http.get(`${this.$baseUrl}/product-detail/${this.pid}`)
      if (res.meta.status !== 200) return this.$message.error('获取商品失败！')
      this.product = res.data
      this.goodsList = this.product.prod_pics.map((item) => ({
        name: this.product.item_cn,
        img: item.publicUrl,
        thumbs: item.publicUrl
      }))
      this.goodsListEn = this.product.prod_pics.map((item) => ({
        name: this.product.item_en,
        img: item.publicUrl,
        thumbs: item.publicUrl
      }))
    },
    async getSimProds() {
      const { data: res } = await this.$http.get(`${this.$baseUrl}/get-sim-prod/${this.pid}`)
      if (res.meta.status !== 200) return this.$message.error('获取商品失败！')
      this.recList = res.data.map((item) => ({
        id: item._id,
        img: item.avatarPublicUrl,
        name: item.item_cn,
        sku: item.sku,
        upc: item.upc
      }))
      this.recListEn = res.data.map((item) => ({
        id: item._id,
        img: item.avatarPublicUrl,
        name: item.item_en,
        sku: item.sku,
        upc: item.upc
      }))
    },
    initListener() {
      this.$_resizeHandler = this.myDebounce(() => {
        this.changeBanner()
      })
      window.addEventListener('resize', this.$_resizeHandler)
    },
    destroyListener() {
      window.removeEventListener('resize', this.$_resizeHandler)
      this.$_resizeHandler = null
    },
    changeBanner() {
      this.showDetail = window.innerWidth > 767
    }
  },
  watch: {
    '$i18n.locale'(newValue) {
      this.lang = newValue
    }
  }
}
</script>

<style scoped lang="scss">
//product-detail
.product-detail {
  padding: 66px 0;
  .top-info {
    display: flex;
    .left {
      width: 0;
      flex: 0 0 480px;
      margin-right: 120px;
    }
    .right {
      .title {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        margin: 10px 0 24px;
      }
      .form {
        .row {
          display: flex;
          align-items: flex-start;
          line-height: 21px;
          .label {
            flex: 0 0 70px;
            margin-right: 16px;
            @extend .semibold-14px;
          }
          .value {
            flex: 1;
            @extend .regular-14px;
          }
        }
        .row + .row {
          margin-top: 16px;
        }
      }
    }
  }
  .detail {
    padding: 80px 0;
    .title {
      @extend .h3-24px;
      margin-bottom: 8px;
    }
    .content {
      h3 {
        @extend .semibold-14px;
        margin-bottom: 8px;
      }
      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 8px;
      }
    }
  }
  .rec {
    .title {
      font-weight: 700;
      font-size: 24px;
      line-height: 150%;
      margin-bottom: 32px;
    }
    .goods-list2 {
      margin: 0 -10px;
      .goods-item {
        flex: 0 0 calc(20% - 20px);
        margin: 0 10px;
      }
    }
  }
}
.product-detail .detail .title .icon {
  display: none;
}
@media only screen and (max-width: 959px) {
  .product-detail .top-info .left {
    width: 100%;
    margin-bottom: 20px;
  }
  .product-detail .top-info {
    display: block;
  }
  .product-detail {
    padding: 30px 0;
  }
}
@media only screen and (max-width: 767px) {
  .product-detail .top-info .left {
    margin-bottom: 0;
  }
  .product-detail .top-info .right .title {
    font-size: 20px;
  }
  .product-detail .detail {
    padding: 20px 0;
    margin: 20px 0;
    border-top: 1px solid #dddbcb;
    border-bottom: 1px solid #dddbcb;
  }
  .product-detail .detail .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
    .icon {
      display: block;
      width: 24px;
      height: 24px;
      background: url('~@/assets/images/add.png') no-repeat center center / contain;
    }
    .icon.open {
      background-image: url(~@/assets/images/redu.png);
    }
  }
  .product-detail .detail .content {
    margin-top: 20px;
  }
  .product-detail .rec .title {
    margin-bottom: 20px;
    font-weight: 600;
  }
  .product-detail .rec .goods-list2 {
    margin: 0;
    overflow-x: auto;
    flex-wrap: nowrap;
    .goods-item {
      flex: 0 0 138px;
      margin: 0 10px 0 0;
    }
  }
}
</style>
